import { collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import { getArtworkById } from './artworkService';
import { Artwork } from '../types';

export const getRecentlyViewed = async (userId: string): Promise<Artwork[]> => {
  try {
    const q = query(
      collection(db, 'views'),
      where('userId', '==', userId),
      orderBy('lastViewedAt', 'desc'),
      limit(10)
    );

    const querySnapshot = await getDocs(q);
    const artworkIds = querySnapshot.docs.map(doc => doc.data().artworkId);
    
    // Fetch full artwork details
    const artworkPromises = artworkIds.map(id => getArtworkById(id));
    const artworks = await Promise.all(artworkPromises);
    
    return artworks.filter(artwork => artwork !== null) as Artwork[];
  } catch (error) {
    console.error('Error getting recently viewed:', error);
    return [];
  }
};